<app-chart [title]="title" [tooltip]="tooltip">
  <div class="content">
    <div
      echarts
      [options]="options"
      [merge]="options"
      class="pie-animation-chart"
      [autoResize]="true"
      (chartClick)="onChartClick($event)"
    ></div>
  </div>
</app-chart>
